import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeriesChooserComponent } from './series-chooser.component';
import {RouterModule} from '@angular/router';
import {PagesModule} from '../pages.module';
import {AngularCountdownTimerModule} from 'angular8-countdown-timer';
import {MatIconModule} from '@angular/material';
import {FlexModule} from '@angular/flex-layout';
import {CountdownTimerModule} from '../countdown-timer/countdown-timer.module';



@NgModule({
  declarations: [SeriesChooserComponent],
  exports: [
    SeriesChooserComponent
  ],
    imports: [
        CommonModule,
        RouterModule,
        PagesModule,
        AngularCountdownTimerModule,
        MatIconModule,
        FlexModule,
        CountdownTimerModule
    ]
})
export class SeriesChooserModule { }
